<template>
    <span style="width: 50%;">
        <CDropdown 
            v-show="mostrarColSeccionActualizar()"
            color="drpdwn-menu"
            class="mt-1"
            size="sm"
            style="width: 50%;">
            <template #toggler-content>
                <CIcon :content="$options.freeSet.cilApplications" :class="(isActualizandoDocumentos) ? 'imgr' : ''" /> Opciones Documentos
            </template>
            <div role="group">
                <CDropdownItem  
                    @click="cambiarMostrarSubirDocumentos()">
                    <CIcon class="mr-1" :content="$options.freeSet.cilCloudUpload" /> 
                    {{(mostrarSubirDocumentos) ? 'Cerrar ':''}}Subir Documentos 
                </CDropdownItem>
                
                <!--<CDropdownItem  
                    v-show="mostrarSubirDocumentos"
                    @click="cambiarMostrarSubirDocumentos()">
                    <CIcon class="mr-1" :content="$options.freeSet.cilCloudUpload" /> 
                    Cerrar Subir Documentos 
                </CDropdownItem>-->
                <!--
                    :content="(empresa.mostrarMensajeActualizacionDocumentos)?empresa.mensajeActualizacionDocs:'Actualizar Documentos'"                                            
                    v-tippy="{ 
                        placement: 'top',
                        arrow: true, 
                        arrowType: 'round', 
                        animation:'fade',
                        theme: 'google',
                        followCursor : true,
                    }"
                -->
                <!---->
                <CDropdownItem
                    v-show="mostrarColSeccionActualizar()"
                    @click="actualizarDocumentosEmpresa()"
                    v-tippy="getBaseTippy(`${(mostrarMensajeActualizacionDocumentos)?ultimoMensajeActualizacionDocs:'Actualizar Documentos'}`)"
                    >
                    <CIcon class="mr-1" :content="$options.freeSet.cilLoopCircular" :class="(isActualizandoDocumentos) ? 'imgr' : ''" /> 
                    <!--{{empresa.isActualizandoDocumentos?"Actualizando ": "Actualizar "}}-->Actualizar Documentos
                    
                    <!--<CIcon 
                        class="ml-1"
                        v-show="empresa.mostrarMensajeActualizacionDocumentos"
                        :content="$options.freeSet.cilInfo"
                        
                    />-->
                    <CIcon 
                        v-show="mostrarMensajeActualizacionDocumentos"
                        class="ml-1"
                        :content="$options.freeSet.cilInfo"
                        
                    />
                    
                </CDropdownItem>
            </div>
            
        </CDropdown>
    </span>
</template>

<script>
    import cons from '@/const'
    import { freeSet } from "@coreui/icons";
    import { CCol, CIcon } from '@coreui/vue';
    import axios from "axios"
    import { es } from 'date-fns/locale';
    import apiUrls from '@/views/utils/apiUrls'
    import * as util from '@/views/utils/utilsFunctions'


    export default {
        name: "ActualizacionDocumentos",
        freeSet,
        props: {
            tipoDocumentoSelected: {
                type: Object,
                default: null
            },
            periodoSelected: {
                type: Object,
                default: null
            },
            mesSelected: {
                type: Object,
                default: null
            },
            mostrarSubirDocumentos: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                urlBase: cons.port+"://" + cons.ipServer,
                tokenLogin: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
                isActualizandoDocumentos: false,
                ultimoMensajeActualizacionDocs: "",
                mostrarMensajeActualizacionDocumentos: false,
                
            }
        },
        mounted() {
        },
        beforeDestroy() {
        },
        methods: {
            // FUNCIONES DE EVENTOS / COMUNICACIÓN CON PADRE
            cambiarMostrarSubirDocumentos() {
                this.$emit("cambiarMostrarSubirDocumentos", !this.mostrarSubirDocumentos)
            },

            // FUNCIONES DE VALIDACIÓN / VISIBILIDAD UI
            mostrarColSeccionActualizar() {
                if (!this.tipoDocumentoSelected) return false
                if (this.tipoDocumentoSelected.valor === 'contratos') return false
                if (!this.periodoSelected || !this.mesSelected) return false
                return true
            },

            // FUNCIONES DE ACTUALIZACIÓN DE DOCUMENTOS (API)
            actualizarDocumentosEmpresa() {
                this.isActualizandoDocumentos = true
                let url = this.urlBase + apiUrls.remuneraciones.revisarActualizarDocumentos

                axios({
                    method: "POST", 
                    url: url,
                    data: {
                        infoActualizar: {
                            tipoBD: "REMU",
                            tipoDocumentos: this.tipoDocumentoSelected.valor
                        }
                    },
                    headers: {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    this.mostrarNotificaciones(2, result.data.mensajeGeneral)
                    if (result.data.validoContinuar) {
                        this.actualizarDocumentosEncontrados()
                    }
                }).catch(() => {
                    // Manejo de error silencioso o a completar
                }).finally(() => {
                    // Finalización silenciosa
                })
            },

            actualizarDocumentosEncontrados() {
                this.mostrarMensajeActualizacionDocumentos = false
                this.ultimoMensajeActualizacionDocs = "Actualizando Documentos"
                
                let url = this.urlBase + apiUrls.remuneraciones.actualizarDocumentos

                axios({
                    method: "POST",
                    url: url,
                    data: {
                        infoActualizar: {
                            tipoBD: "REMU",
                            tipoDocumentos: this.tipoDocumentoSelected.valor,
                            mes: this.mesSelected.valor,
                            anio: this.periodoSelected.valor
                        }
                    },
                    headers: {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    this.mostrarNotificaciones(1, result.data.mensajeGeneral, 20)

                    result.data.archivosProcesados.forEach(archivo => {
                        archivo.id = Date.now().toString(36) + Math.random().toString(36).substr(2, 9)
                        util.manejoHistorialDocumentos(archivo, 'Actualizar Documentos')
                    })

                    this.isActualizandoDocumentos = false
                    this.mostrarMensajeActualizacionDocumentos = true
                    this.ultimoMensajeActualizacionDocs = result.data.mensajeGeneral
                }).catch(error => {
                    if ("tipoMensaje" in error.response.data && "mensajeGeneral" in error.response.data) {
                        const tipo = error.response.data.tipoMensaje
                        const mensaje = error.response.data.mensajeGeneral
                        this.mostrarNotificaciones(tipo === "alerta" ? 2 : 3, mensaje)
                    } else {
                        this.mostrarNotificaciones(3, error.response.data.mensajeGeneral)
                    }

                    this.isActualizandoDocumentos = false
                    this.mostrarMensajeActualizacionDocumentos = true
                    this.ultimoMensajeActualizacionDocs = error.response.data.mensajeGeneral
                }).finally(() => {
                    // Finalización sin acción adicional
                })
            }
        }
    }
</script>

<style scoped>

</style>